import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSectionNavigation = (sectionId: string) => {
    // Wenn wir auf der Startseite sind, scrolle zur Sektion
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Wenn wir auf einer anderen Seite sind, navigiere zur Startseite mit Anker
      navigate(`/#${sectionId}`);
    }
    setIsMenuOpen(false);
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/d6212764e2e22a594116bb5aaa2c701d/113ea802684e94d3fd36db6d42d2fb18.png" 
              alt="Aeroscan360 Logo" 
              className="h-10 w-auto cursor-pointer"
              onClick={() => navigate('/')}
            />
          </div>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <button 
                onClick={() => handleSectionNavigation('home')}
                className="text-gray-900 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Startseite
              </button>
              <button 
                onClick={() => handleSectionNavigation('services')}
                className="text-gray-900 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Dienstleistungen
              </button>
              <button 
                onClick={() => handleSectionNavigation('about')}
                className="text-gray-900 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Über uns
              </button>
              <button 
                onClick={() => handleSectionNavigation('contact')}
                className="bg-teal-600 text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                Kontakt
              </button>
            </div>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-900 hover:text-teal-600 p-2 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t">
              <button 
                onClick={() => handleSectionNavigation('home')}
                className="block text-gray-900 hover:text-teal-600 px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Startseite
              </button>
              <button 
                onClick={() => handleSectionNavigation('services')}
                className="block text-gray-900 hover:text-teal-600 px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Dienstleistungen
              </button>
              <button 
                onClick={() => handleSectionNavigation('about')}
                className="block text-gray-900 hover:text-teal-600 px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Über uns
              </button>
              <button 
                onClick={() => handleSectionNavigation('contact')}
                className="block bg-teal-600 text-white px-3 py-2 text-base font-medium w-full text-left rounded-lg hover:bg-teal-700 transition-colors cursor-pointer"
              >
                Kontakt
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
